import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=35ea586c"
import script from "./SignInPage.vue?vue&type=script&lang=js"
export * from "./SignInPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports